import { render, staticRenderFns } from "./horizontalInfographic.vue?vue&type=template&id=f871b4ec&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./horizontalInfographic.vue?vue&type=script&lang=js&"
export * from "./horizontalInfographic.vue?vue&type=script&lang=js&"
import style0 from "./horizontalInfographic.scss?vue&type=style&index=0&id=f871b4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f871b4ec",
  null
  
)

export default component.exports